// extracted by mini-css-extract-plugin
export var active = "mobile-language-switch-module--active--f440c";
export var author = "mobile-language-switch-module--author--8723a";
export var category = "mobile-language-switch-module--category--804dd";
export var headline = "mobile-language-switch-module--headline--53f4d";
export var headlinePost = "mobile-language-switch-module--headline-post--2f597";
export var mobileLanguageSwitch = "mobile-language-switch-module--mobile-language-switch--3c0fa";
export var mobileLanguageSwitchItem = "mobile-language-switch-module--mobile-language-switch-item--14114";
export var paragraph = "mobile-language-switch-module--paragraph--abcef";